import { ContentSection, ItemTeaser, Layout, PageWrap, SectionHeading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { BrandType } from "@bus/models";
import { CustomerHappiness } from "../components/customer-happiness-index";
import { capitalizeBrand } from "../helpers/capitalizeBrand";

export const ConfirmationPage = () => {
    const { t } = useTranslation("confirmationpage");
    const { dealersList, submitAnswersRequest, defaultDealer } = useMatchMakerWizard();
    const dealerSeleted = dealersList.find((x) => x.id === submitAnswersRequest.selectedDealer) ?? defaultDealer;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const getTitle = () => {
        switch (brand) {
            case BrandType.AUDI:
            case BrandType.SEAT:
            case BrandType.VWN:
                return t("confirmationpage:titleAlternative")
            default:
                return t("confirmationpage:title");
        }
    }
    const getText = () => {
        switch (brand) {
            case BrandType.AUDI:
                return t("confirmationpage:textAlternative", 
                    {partnerType: t('confirmationpage:partnerType.service')});
            case BrandType.VW:
            case BrandType.VWN:
            case BrandType.SKODA:
                return t("confirmationpage:textAlternative",
                    {partnerType: t('confirmationpage:partnerType.default')});
            default:
                return t("confirmationpage:text");
        }
    }

    const getContactTitle = () => {
        switch (brand) {
            case BrandType.AUDI:
                return t("confirmationpage:contact-titleAudi")
            case BrandType.VWN:
                return t("confirmationpage:contact-titleVWN")
            case BrandType.VW:
                return t("confirmationpage:contact-titleVW")
            default:
                return t("confirmationpage:contact-title", {
                    brand: capitalizeBrand(brand as BrandType),
                })
            }
    }
    return (
        <>
            <ContentSection>
                <PageWrap>
                    <div className="u-text-center">
                        <i className="c-icon c-icon--xxlarge c-icon--[semantic-success] u-text-success" />
                    </div>
                </PageWrap>
            </ContentSection>

            <ContentSection>
                <PageWrap size="small">
                    <div className="u-text-center">
                        <SectionHeading level={1}>{getTitle()}</SectionHeading>
                        <div>{getText()}</div>
                    </div>
                </PageWrap>
            </ContentSection>

            <ContentSection>
                <PageWrap size="small">
                    <Layout center>
                        <Layout.Item default="1/2" xs="1/1">
                            <ItemTeaser
                                testId="confirmationpage:contact"
                                inline
                                icon="semantic-dealer"
                                title={getContactTitle()}
                                headingLevel={2}
                                semanticContainer="article"
                            >
                                {dealerSeleted?.name}
                                <br />
                                {dealerSeleted?.phoneCountryCode} {dealerSeleted?.phone}
                            </ItemTeaser>
                        </Layout.Item>
                    </Layout>
                </PageWrap>
            </ContentSection>
            <CustomerHappiness/>
        </>
    );
};
